import {FRDataRetriever} from "#Formulas/FormulaCore/Elements/FRField/FRDataRetriever";

export class FormDataRetriever extends FRDataRetriever{
    public Container:any;
    public Form:HTMLDivElement;
    constructor(public Field:HTMLDivElement) {
        super();

    }

    GetForm(): HTMLDivElement {
        if(this.Form==null)
            this.Form=this.Field.closest('form.wpforms-form') as HTMLDivElement;
        return this.Form;
    }
    GetFieldById(id: string): any {
        let field=this.GetForm().querySelector('.wpforms-field[data-field-id="'+id+'"]');

        if(field==null)
            return '';

        let inputs=field.querySelectorAll('input,select,textarea');
        let result='';

        let addItem=(item)=>{
            if(item==null||item=='')
                return;

            if(!isNaN(Number(item)))
                item=Number(item);

            if(result==='')
                result=item;
            else
                result+=item;
        };

        inputs.forEach((input:HTMLInputElement)=>{
            switch (input.tagName)
            {
                case 'SELECT':
                    let selectedOption=input.querySelector('option:checked');
                    if(selectedOption==null)
                        return null;

                    if(selectedOption.hasAttribute('data-amount'))
                        addItem(selectedOption.getAttribute('data-amount'));
                    else
                        addItem(selectedOption.getAttribute('value'));
                    break;
                default:
                    if(input.type.toLowerCase()=='checkbox'||input.type.toLowerCase()=='radio')
                    {
                        if(!input.checked)
                            return;
                    }

                    if(input.hasAttribute('data-amount'))
                        addItem(input.getAttribute('data-amount'));
                    else
                        addItem(input.value);

            }
        });


        return result;
    }

}